export default "__VITE_ASSET__DguO8plc__"